export const APOLLO_CLIENT_CONSTS = {
    error400: 'Плохой запрос.',
    error403: 'Нет прав доступа к содержимому, поэтому сервер отказывается дать надлежащий ответ.',
    error409: 'Конфликт версий данных, пожалуйста обновите страницу.',
    error501: 'Не выполнено(метод запроса не поддерживается сервером и не может быть обработан).',
    error502: 'Недопустимый ответ сервера.',
    error503: 'Ошибка соединения с сервером.',
    error504: 'Превышен лимит времени ожидания ответа от сервера, пожалуйста повторите попытку позже.'
}